import Sticky from 'sticky-js';
import Turbolinks from 'turbolinks';

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['history', 'query', 'mode'];

  initialize() {
    this.queryTarget.addEventListener('click', () => this.showHistory());
    this.queryTarget.addEventListener('keydown', () => this.showHistory());
    this.queryTarget.addEventListener('blur', () => this.hideHistory());

    // this.element.parentElement.style.height = this.element.offsetHeight + 'px';
  }

  connect() {
    // this.element.parentElement.style.height = this.element.offsetHeight + 'px';
    new Sticky('.search');

    // if (document.querySelectorAll('input[autofocus="autofocus"]').length <= 0) {
    //   this.queryTarget.focus();
    // }
  }

  disconnect() {
    const sticky = new Sticky('.search');
    sticky.destroy();
  }

  submit(event) {
    event.preventDefault();

    Turbolinks.visit(`/parts/search?query=${encodeURIComponent(this.queryTarget.value)}&mode=${this.modeTarget.value}`);
  }

  showHistory() {
    this.historyTarget.classList.add('is-active');
  }

  hideHistory() {
    this.historyTarget.classList.remove('is-active');
  }
}
